import React, { useEffect, useState } from 'react';
import _ from 'underscore';

function LinkedLbsSources(props) {
	const [data, setData] = useState(null);

	const sources = {
		'nafnid': {
			label: 'Nafnið.is',
			url: 'https://nafnid.is/baer/'
		},
		'ismus': {
			label: 'Ísmús',
			url: 'https://ismus.is/stadir/'
		},
		'vesturheimsrit': {
			label: 'Handrit íslendinga í vesturheimi',
			url: 'https://vesturheimur.arnastofnun.is/stadir/'
		},
		'lbs': {
			label: 'Handrit.is',
			url: 'https://handrit.is/manuscript/list/places/'
		}
	};

	useEffect(() => {
		fetch('https://ismus.is/baejatal-sources/lbs_key?key='+props.lbs_key)
			.then(res => res.json())
			.then(json => {
				let filteredData = _.reject(json, (item) => item.source == props.current);
				setData(filteredData);
			})
			.catch(error => {
			});
	}, [props.lbs_key]);

	return (
		<div className="card gray-card mt-3">
			<div className="card-body">
				<div className="mb-3">Tenglar sem vísa á sama efni á öðrum tegndum vefjum.</div>
				<div className="d-flex">
					{
						data && data.map((item, index) => <span key={index} className="mr-5">
							<a target="_blank" href={sources[item.source].url+item.id}>{sources[item.source].label}<br/><small>({item.name})</small></a>
						</span>)
					}
				</div>
			</div>
		</div>
	)
}

export default LinkedLbsSources;
